<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="triggerCloseModal()")
      .modal-wrapper(@click.self="triggerCloseModal()")
        .modal-container.modal-trocar-responsavel
          .modal-header
            p.title {{processo.idUsuario ? 'Trocar Responsável' : 'Vincular Responsável'}}
            el-button.btn#btn(
              type="text",
              @click="triggerCloseModal()",
              size="mini"
            )
              i.material-icons.icon close
          .modal-body()
            div
              el-row.row
                p Processo:
                  b &nbsp {{processo.numeroProcesso}}
              el-row.row
                p Selecione abaixo o nome do responsável a ser vinculado no processo:
              el-row.row
                el-select.full-width(
                  v-model='usuarioVinculado',
                  placeholder='Selecione o responsável',
                  no-match-text="Usuário não encontrado",
                  no-data-text="Nenhum usuário disponível",
                  filterable,
                  clearable,
                  :id="'id-selecionar-responsavel'"
                )
                  el-option.listResponsavel(
                    v-for='usuario in usuariosDisponiveis',
                    :key='usuario.id',
                    :label='usuario.nomeCargo',
                    :value='usuario.id'
                  )
          .modal-footer
            slot(name="footer")
              el-button(@click="trocar", :disabled="notAnalistaOrGente") Confirmar

</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
export default {
  props: {
    processo: {
      type: Object,
      required: true
    }
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      colorCopy: '#666666',
      hoverColor: '#079D67',
      usuarioVinculado: null,
      usuariosDisponiveis: [],
      usuario: {},
      notAnalistaOrGente: false
    }
  },

  async created () {
    this.usuariosDisponiveis = await this.getUsuarios(this.processo.id)
    this.usuariosDisponiveis = await this.usuariosDisponiveis.filter(usuario => usuario.id !== this.processo.idUsuario)
    this.usuario = await this.getUsuario()
    if (this.usuariosDisponiveis.length === 0) {
      this.notAnalistaOrGente = true
    }
  },

  computed: {

  },

  methods: {
    ...mapActions({
      getUsuarios: 'dados/getUsuarios',
      trocarResponsavel: 'dados/trocarResponsavel',
      getUsuario: 'auth/getUsuario'
    }),

    trocar () {
      if (this.usuarioVinculado) {
        const processo = {
          id: this.processo.id,
          usuario: {
            id: this.usuarioVinculado
          }
        }
        this.trocarResponsavel(processo).then(() => {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Responsável alterado com sucesso'
          )
          this.$emit('refresh')
          this.triggerCloseModal()
        }).catch(() => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            'Não foi possível trocar o responsável'
          )
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Escolha um responsável!'
        )
      }
    },

    triggerCloseModal () {
      this.$emit('closeModal')
    }

  }
}
</script>

<style scoped lang="scss">
.modal-trocar-responsavel {
  height: 20em;
  width: 40em;
}

.modal-mask {
  position: fixed;
  z-index: 8;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.full-width {
  width: 95%;
}

.modal-wrapper {
  margin-top: 8vh;
}

.modal-container {
  min-height: 200px;
  max-height: 84vh;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #009f60;
  border-radius: 10px 10px 0 0;
  height: 55px;
}

.modal-body {
  padding: 10px;
  margin: 10px 30px;
  overflow-y: auto;
  max-height: 76vh;
  flex-grow: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  background-color: white;
  padding: 10px;
  border-radius: 0px 0px 10px 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  margin: 0;
  font-size: 18px;
  color: white !important;
  font-weight: bold;
  padding: 0 10px;
  margin-bottom: 0px !important;
}

.btn {
  padding-right: 20px;
  color: white;

  .icon {
    font-size: 18px;
  }
}

@media (max-width: 780px) {
  .modal-trocar-responsavel {
    width: 23em;
  }

  .listResponsavel {
    left: 115px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/ModalTrocarResponsavel.vue